import script from "./settle.vue?vue&type=script&setup=true&lang=js"
export * from "./settle.vue?vue&type=script&setup=true&lang=js"

import "./settle.vue?vue&type=style&index=0&id=56bad8fe&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bad8fe"]])

export default __exports__